import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4948c83c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg width=\"30\" height=\"26\" data-v-4948c83c><path d=\"M0,2 30,2\" stroke=\"red\" stroke-width=\"3\" data-v-4948c83c></path><path d=\"M0,9 30,9\" stroke=\"red\" stroke-width=\"3\" data-v-4948c83c></path><path d=\"M0,16 30,16\" stroke=\"red\" stroke-width=\"3\" data-v-4948c83c></path><path d=\"M0,23 30,23\" stroke=\"red\" stroke-width=\"3\" data-v-4948c83c></path></svg>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "navbar-nav",
  style: {"color":"white","padding":"7px","font-size":"22px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "navbar-nav" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "txt",
      style: {"color":"white","text-align":"right","font-size":"19px","padding-right":"5px","margin-top":"-36px"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "date",
      style: {"color":"white","text-align":"right","font-size":"14px","padding-right":"5px"}
    })
  ])
], -1))
const _hoisted_6 = {
  id: "side-menu",
  class: "side-nav"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu" }, "Menu", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users-cog" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-4948c83c><div class=\"separator2\" data-v-4948c83c></div><div class=\"separator2\" data-v-4948c83c></div><div class=\"separator\" data-v-4948c83c></div><div class=\"separator\" data-v-4948c83c></div></div>", 1)

import { onMounted} from "vue";
import { today, now } from './common/routines';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: ['title'],
  setup(__props) {

const props = __props;



function openSlideMenu() {
    const sidemenu = document.getElementById('side-menu');
    if (sidemenu != null) {
        sidemenu.style.width = '310px';
    }
}

function closeSlideMenu() {
    const sidemenu = document.getElementById('side-menu');
    if (sidemenu != null) {
        sidemenu.style.width = '0';
    }
}

function startTime() {
    const tdate = document.getElementById('date');
    const ttime = document.getElementById('txt');
    if (ttime != null) {
        ttime.innerHTML = now();
    }
    if (tdate != null) {
        tdate.innerHTML = today();
    }
    setTimeout(startTime, 500);
}

onMounted(() => {
    console.log("NavBar");
    startTime();
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("span", { class: "open-slide" }, [
        _createElementVNode("a", {
          href: "#",
          onClick: openSlideMenu
        }, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(props.title), 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: "#",
          class: "btn-close",
          onClick: closeSlideMenu
        }, "×")
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "botonete"
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createTextVNode("  "),
            _createElementVNode("b", null, _toDisplayString(_ctx.$t("NavBar.HomePage")), 1),
            _hoisted_9,
            _createTextVNode(_toDisplayString(_ctx.$t("NavBar.HomePageDes")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: "/users",
          class: "botonete"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createTextVNode("  "),
            _createElementVNode("b", null, _toDisplayString(_ctx.$t("NavBar.UserPage")), 1),
            _hoisted_11,
            _createTextVNode(_toDisplayString(_ctx.$t("NavBar.UserPageDes")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_12
  ], 64))
}
}

})